var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileZuumuck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 149,
    viewBox: "0 0 151 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.375 92.4531C134.465 129.941 95.5685 152.394 57.4982 142.611C19.4346 132.828 -3.39533 94.5067 6.51453 57.0258C7.37709 53.7675 8.45529 50.6193 9.74216 47.594C23.1869 15.8699 58.6371 -2.07015 93.3918 6.86127C131.462 16.6444 154.285 54.9657 144.375 92.4531Z",
    fill: "white",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60487 47.7409C9.60487 47.7409 35.0117 37.9329 35.3988 59.3473C35.7682 79.4693 30.5241 73.5981 37.8607 103.454C37.8607 103.454 43.1399 122.881 28.0845 126.617",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0984 11.6844C44.0984 11.6844 28.476 62.5911 46.9658 67.4996C54.5269 69.507 59.0263 64.836 60.5922 57.4903C62.7351 47.4318 63.7674 37.0404 67.5845 25.5964C71.3519 14.2961 80.3643 4.93483 80.3643 4.93483",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8289 50.1876C61.0157 54.3777 64.2076 71.5603 80.3489 62.5015C84.3311 60.2643 86.0579 55.4566 87.3061 51.1625C90.5107 40.0958 96.7207 20.0116 107.953 13.0883",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6839 53.0855C85.8473 59.1211 95.5289 72.1252 107.266 59.3297C108.17 58.342 111.321 51.9418 112.287 49.6322C114.701 43.8614 119.607 33.3082 127.206 28.2866",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.268 52.7223C110.268 52.7223 111.115 78.9553 130.71 57.9173C133.364 55.0668 135.779 51.1631 139.078 46.4148",
    stroke: "#231815",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.704 107.618C73.8367 111.059 87.7899 114.604 99.9668 106.157",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.116 91.1585C105.788 91.1585 107.953 89.001 107.953 86.3395C107.953 83.6781 105.788 81.5205 103.116 81.5205C100.445 81.5205 98.2793 83.6781 98.2793 86.3395C98.2793 89.001 100.445 91.1585 103.116 91.1585Z",
    fill: "#231815",
    stroke: "#231815",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1113 92.6063C64.7826 92.6063 66.9482 90.4487 66.9482 87.7873C66.9482 85.1258 64.7826 82.9683 62.1113 82.9683C59.44 82.9683 57.2744 85.1258 57.2744 87.7873C57.2744 90.4487 59.44 92.6063 62.1113 92.6063Z",
    fill: "#231815",
    stroke: "#231815",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6777 95.8891C88.4461 97.552 86.1094 98.7873 83.4457 98.6448C80.782 98.5023 78.8132 97.0362 79.038 95.3733C79.2628 93.7104 81.6063 92.4751 84.27 92.6176C86.9337 92.7602 88.9025 94.2262 88.6777 95.8891Z",
    fill: "#231815",
    stroke: "#231815",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileZuumuck);
export default __webpack_public_path__ + "static/media/profileZuumuck.4d135bf1b0bc4ddb635269df1dec39ab.svg";
export { ForwardRef as ReactComponent };